var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReturn({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 6.74975H5.576L6.546 5.77975C6.839 5.48675 6.839 5.01275 6.546 4.71975C6.253 4.42675 5.778 4.42675 5.485 4.71975L3.269 6.93675C3.107 7.07375 3 7.27075 3 7.49975C3 7.72775 3.107 7.92475 3.268 8.06175L5.476 10.2787C5.622 10.4267 5.814 10.4998 6.007 10.4998C6.198 10.4998 6.39 10.4267 6.536 10.2807C6.83 9.98875 6.83 9.51475 6.538 9.22075L5.571 8.24975H15C17.481 8.24975 19.5 10.2688 19.5 12.7498C19.5 15.2308 17.481 17.2498 15 17.2498H10.61C10.196 17.2498 9.86 17.5858 9.86 17.9998C9.86 18.4138 10.196 18.7498 10.61 18.7498H15C18.309 18.7498 21 16.0588 21 12.7498C21 9.44075 18.309 6.74975 15 6.74975",
    fill: "#0F67BF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReturn);
export default __webpack_public_path__ + "static/media/Return.98c3458ce6ba700256b07f9ae071f658.svg";
export { ForwardRef as ReactComponent };